module.exports = __webpack_public_path__ + "static/media/AIYA_Bot_Blank.25ca56a5.jpg";